import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';
import { LogisticService, OperationItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-custact-work',
  templateUrl: './custact-work.component.html',
  styleUrls: ['./custact-work.component.css']
})
export class CustactWorkComponent implements OnInit {
    custactNo;

    public equipmentsButtons: FormButton[] = [{ id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('equipment_id') }];

    public custactWorkKeyno: string;

    public info?: Info;

    public edit?: Edit;

    public selectListOperations: OperationItem[] = [];

    public selectListEquipments: Item[] = [];

    public savingAndNew = false;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private utility: UtilityService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
        this.custactWorkKeyno = this.stateService.getStateParams()['custactwork_keyno'];
    }

    private async loadInfo() {
        if (!!this.custactNo) {
            this.info = (await this.datatask.Post(28, { custact_no: this.custactNo }))[0];
        }
    }

    private async loadEdit() {
        if (!!this.custactNo && !!this.custactWorkKeyno) {
            this.edit = (await this.datatask.Post(378, {
                custact_no: this.custactNo,
                custactwork_keyno: this.custactWorkKeyno
            }))[0];
        }
    }

    private async loadOperations() {
        this.selectListOperations = await this.logistic.getOperations({ direct: '1' });
    }

    private async loadEquipments() {
        if (!this.edit) return;

        return this.selectListEquipments = await this.logistic.getEquipments({ operation_id: this.edit.operation_id });
    }

    private async retrieveProduct() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(379, {
            operation_id: this.edit.operation_id,
            equipment_id: this.edit.equipment_id
        }))[0];

        this.edit.prod_id = response?.prod_id;
        this.edit.prodsize_keyno = response?.prodsize_keyno;
        this.edit.prodchoice_keyno = response?.prodchoice_keyno;
    }

    private async retrievePrice() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(380, {
            custact_no: this.edit.custact_no,
            operation_id: this.edit.operation_id,
            equipment_id: this.edit.equipment_id,
            prod_id: this.edit.prod_id,
            prodsize_keyno: this.edit.prodsize_keyno,
            prodchoice_keyno: this.edit.prodchoice_keyno
        }))[0];

        this.edit.cost_price_invval = response?.cost_price_invval;
        this.edit.ordval_price_brt = response?.ordval_price_brt;
    }

    public async saveAndNewChanges() {
        if (!!this.edit) {
            try {
                this.savingAndNew = true;

                await this.datatask.Post(398, this.edit);

                this.stateService?.go('custactwork', {
                    custact_no: this.edit!.custact_no,
                    custactwork_keyno: '0'
                });

                await this.loadEdit();
                this.loadInfo();
                this.loadOperations();
                this.loadEquipments();
            } finally {
                this.savingAndNew = false;
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(398, this.edit);

                this.stateService.back('/custactworks/' + this.edit!.custact_no);
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(577, { custactwork_keyno: this.edit.custactwork_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private calculateCost() {
        if (!!this.edit) {
            this.edit.cost_locval = this.utility.parseNumber(this.edit.cost_price_invval) * this.utility.parseNumber(this.edit.quantity_hours);
        }
    }

    private calculatePrice() {
        if (!!this.edit) {
            this.edit.ordval_amount_net = this.utility.parseNumber(this.edit.ordval_price_brt) * this.utility.parseNumber(this.edit.quantity_hours);
        }
    }

    private calculateExchangeAmount() {
        if (!!this.edit) {
            this.edit.locval_amount_net = this.utility.parseNumber(this.edit.ordval_amount_net) * this.utility.parseNumber(this.edit.ordval_exchangefactor);
        }
    }

    private calculateLocValAmount() {
        if (!!this.edit) {
            this.edit.locval_db = this.utility.parseNumber(this.edit.ordval_amount_net) - this.utility.parseNumber(this.edit.cost_locval);
        }
    }

    private async clear(id: string) {
        if (!this.edit) return;

        switch (id) {
            case 'equipment_id':
                this.edit!.equipment_id = '';

                await this.retrieveProduct();

                Promise.all([
                    this.retrievePrice()
                ]).then(() => {
                    this.calculateCost();
                    this.calculatePrice();
                    Promise.resolve();
                });
                break;
            default:
                break;
        }
    }

    public async onChanged(_: string | number, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'operation_id':
                this.loadEquipments();
                await this.retrieveProduct();

                Promise.all([
                    this.retrievePrice()
                ]).then(() => {
                    this.calculateCost();
                    this.calculatePrice();
                    Promise.resolve();
                });
                break;
            case 'quantity_hours':
                this.calculateCost();
                this.calculatePrice();
                break;
            case 'equipment_id':
                await this.retrieveProduct();

                Promise.all([
                    this.retrievePrice()
                ]).then(() => {
                    this.calculateCost();
                    this.calculatePrice();
                    Promise.resolve();
                });
                break;
            case 'ordval_amount_net':
                this.calculateExchangeAmount();
                this.calculateLocValAmount();
                break;
            case 'cost_locval':
                this.calculateLocValAmount();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadInfo();
        this.loadOperations();
        this.loadEquipments();
    }

    ngOnInit() {
        this.init();
    }
}

interface Info {
    custactinfotext: string;
}

interface Edit {
    custactwork_keyno: string;
    custact_no: string;
    operation_id: string;
    equipment_id: string;
    prod_id: string;
    prodsize_keyno: string;
    prodchoice_keyno: string;
    ordval_price_brt: string;
    cost_price_invval: string;
    quantity: string;
    quantity_hours: string;
    ordval_amount_net: string | number;
    locval_amount_net: string | number;
    cost_locval: string | number;
    bus_valuta_id: string;
    order_valuta_id: string;
    ordval_exchangerate: string;
    ordval_exchangefactor: string;
    locval_db: string | number;
}
